import { Injectable } from '@angular/core'
import { TreeNode } from '../component/tree-search.component'

@Injectable({
  providedIn: 'root',
})
export class TreeSearchService {
  getParents(provider, childNodes) {
    return childNodes
      ?.map((child) => provider.parent(child))
      .reduce(
        (uniqueParents, parent) =>
          uniqueParents.findIndex((el) => el.id === parent.id) === -1 ? [...uniqueParents, parent] : uniqueParents,
        []
      )
  }

  getChildren(provider, childNodes, parent): TreeNode[] {
    const nodes: TreeNode[] = childNodes.filter((child) => provider.parent(child)?.id === parent?.id)
    nodes.forEach((node) => {
      node.parent = parent
    })
    return nodes
  }
}
